import script from "./OrderBook.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderBook.vue?vue&type=script&setup=true&lang=ts"

import "./OrderBook.vue?vue&type=style&index=0&id=47b8db44&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47b8db44"]])

export default __exports__